export default function EmptyApplicationList() {
  return (
    <div className="flex h-[400px] flex-col items-center justify-center gap-lg self-stretch">
      <h3 className="text-heading-xs font-bold">データがありません</h3>
      <img src="/agent/job_change_processes/no-data.svg" alt="" width={148} height={144} />
    </div>
  );
}
